export interface Cat {
  categoryid: number;
  name: string;
}

export async function fetchCategories(): Promise<Cat[]> {
  try {
    const response = await fetch("/api/categories");
    const data = await response.json();
    if (!Array.isArray(data)) {
      throw new Error("Expected an array of categories");
    }
    return data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
}

export async function addCategory(name: string): Promise<void> {
  try {
    const response = await fetch("/api/category", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name: name }),
    });
    if (!response.ok) {
      throw new Error("Failed to add category");
    }
  } catch (error) {
    console.error("Error adding category:", error);
  }
}

export async function deleteCategory(id: number): Promise<void> {
  try {
    const response = await fetch(`/api/category/${id}`, {
      method: "DELETE",
    });
    if (!response.ok) {
      throw new Error("Failed to delete category");
    }
  } catch (error) {
    console.error("Error deleting category:", error);
  }
}
